import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/theme/contrast.css";
import "@/modern/modern.css";
import App from "@/App";
import "@/utils/sessionToken";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
